import Instrumento from "@/models/Instrumento";
import Profissional from "../models/Profissional";

export default class Teste {
  constructor() {
    this.numero = "";
    this.data = new Date();
    this.local = "Base da Netech / Mossoró";
    this.teste = "";
    this.duracao = "";
    this.procedimento = "";
    this.observacao =
      "O equipamento suportou a carga de teste aplicada, sem apresentar desvios ou anômalias que pudessem prejudicar a sua estrutura durante o teste realizado.";
    this.tipo = "Carga(Kg)";
    this.tempo = "Tempo(Minuto)";
    this.resultado = "Aprovado";
    this.unidade = "Mpa - Psi - Bar - Kg - Ton";
    this.instrumento = new Instrumento();
    this.inspetor = new Profissional();
  }

  update(te) {
    this.numero = te.numero;
    this.data = te.data;
    this.local = te.local;
    this.teste = te.teste;
    this.duracao = te.duracao;
    this.procedimento = te.procedimento;
    this.observacao = te.observacao;
    this.tipo = te.tipo;
    this.tempo = te.tempo;
    this.resultado = te.resultado;
    this.instrumento = te.instrumento;
    this.inspetor = te.inspetor;
  }
}
